<template>
    <div>
        <div class="jumbotron nosotros-hero">
            <video autoplay muted loop id="video" class="d-none d-sm-block">
                <source :src="require('../assets/images/Headervideo2-mp4-50.mp4')" type="video/mp4">
            </video>
            <div class="container">
                <div class="row">
                    <div class="col-md-8">
                        <h1 class="text-light">Desde 2007 difundiendo el Talmud en español</h1>
                        <h5 class="text-light">La aplicación Jabrutouch forma parte de Tashemá, un proyecto para divulgar el conocimiento judío a través de publicaciones,  congresos y otras actividades.</h5>
                        <button class="btn btn-primary btn-lg mt-3 px-5 d-none d-sm-block">Contáctanos</button>
                    </div>
                </div>
            </div>
        </div>
        <bottom-shape class="d-none d-sm-block" style="margin-top: -1rem; margin-bottom: 100px!important;" :background="'transparent'"></bottom-shape>
    </div>
</template>
<script>
export default {
    components: {
    }

}
</script>
<style lang="scss">
    .jumbotron.nosotros-hero{
        #video {
            position: absolute;
            right: 0;
            bottom: 0;
            min-width: 100%;
            min-height: 100%;
            z-index: -1;
        }
        background: transparent;
        border-radius: 0;
        position: relative;
        overflow: hidden;
    }
    @media (max-width: 544px) {
        .jumbotron.nosotros-hero{
            background-color: #E0E0E0;
        }
        h1.text-light, h5.text-light{
            color: #000!important;
        }
    }
</style>